// src/components/home/AnnouncementBar.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaRocket, FaStar, FaChartLine, FaHeart, FaTimes, FaExternalLinkAlt, FaArrowRight } from "react-icons/fa";
import AnnouncementNoticeModal from "./AnnouncementNoticeModal";
import "./AnnouncementBar.css";

const AnnouncementBar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [modalState, setModalState] = useState({ isOpen: false, noticeType: "beta" });
  const navigate = useNavigate();

  useEffect(() => {
    const isDismissed = localStorage.getItem("bodhai_announcement_dismissed");
    if (isDismissed === "true") {
      setIsVisible(false);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem("bodhai_announcement_dismissed", "true");
  };

  const openNotice = (type) => {
    setModalState({ isOpen: true, noticeType: type });
  };

  const closeNotice = () => {
    setModalState({ isOpen: false, noticeType: "beta" });
  };

  if (!isVisible) return null;

  return (
    <>
      <div className="bvh-announcement-bar">
        <div className="bvh-announcement-content">
          <div className="bvh-announcement-ticker">
            {/* Notice Item 1: Beta Live Notice Popup trigger */}
            <button
              className="bvh-ticker-item bvh-ticker-btn"
              onClick={() => openNotice("beta")}
              title="Click to view official Beta Notice"
            >
              <FaRocket className="bvh-icon-gold" /> <span>BodhAI V2 Beta is LIVE</span> <span className="bvh-highlight">NOTICE</span>
            </button>
            <span className="bvh-ticker-separator">•</span>
            <div className="bvh-ticker-item">
              <FaStar className="bvh-icon-cyan" /> <span>BodhAI v2.0 Coming Soon</span>
            </div>
            <span className="bvh-ticker-separator">•</span>
            <div className="bvh-ticker-item">
              <FaChartLine className="bvh-icon-purple" /> <span>Smarter AI Engine & New Analytics</span>
            </div>
            <span className="bvh-ticker-separator">•</span>
            {/* Notice Item 4: Product Hunt Notice Popup trigger */}
            <button
              className="bvh-ticker-item bvh-ticker-btn"
              onClick={() => openNotice("ph")}
              title="Click to view official Product Hunt Notice"
            >
              <FaHeart className="bvh-icon-red" /> <span>Support us on Product Hunt</span> <span className="bvh-highlight">NOTICE</span>
            </button>
            <span className="bvh-ticker-separator">•</span>

            {/* Duplicated for seamless 360 loop animation */}
            <button
              className="bvh-ticker-item bvh-ticker-btn"
              onClick={() => openNotice("beta")}
              title="Click to view official Beta Notice"
            >
              <FaRocket className="bvh-icon-gold" /> <span>BodhAI V2 Beta is LIVE</span> <span className="bvh-highlight">NOTICE</span>
            </button>
            <span className="bvh-ticker-separator">•</span>
            <div className="bvh-ticker-item">
              <FaStar className="bvh-icon-cyan" /> <span>BodhAI v2.0 Coming Soon</span>
            </div>
            <span className="bvh-ticker-separator">•</span>
            <div className="bvh-ticker-item">
              <FaChartLine className="bvh-icon-purple" /> <span>Smarter AI Engine & New Analytics</span>
            </div>
            <span className="bvh-ticker-separator">•</span>
            <button
              className="bvh-ticker-item bvh-ticker-btn"
              onClick={() => openNotice("ph")}
              title="Click to view official Product Hunt Notice"
            >
              <FaHeart className="bvh-icon-red" /> <span>Support us on Product Hunt</span> <span className="bvh-highlight">NOTICE</span>
            </button>
            <span className="bvh-ticker-separator">•</span>
          </div>
        </div>

        <div className="bvh-announcement-actions">
          <a
            href="https://betav2.bodhai.pages.dev/"
            target="_blank"
            rel="noopener noreferrer"
            className="bvh-announcement-btn"
          >
            Try Beta <FaArrowRight style={{ fontSize: '0.7rem' }} />
          </a>
          <a
            href="https://www.producthunt.com/products/bodhai?utm_source=bodhai.pages.dev&utm_medium=referral&utm_campaign=bodhai_product_launch_july_2026&utm_content=visit_producthunt_from_bodhai_homepage&utm_term=ai_learning_tool_launch"
            target="_blank"
            rel="noopener noreferrer"
            className="bvh-announcement-btn bvh-ph-btn"
          >
            Product Hunt <FaExternalLinkAlt style={{ fontSize: '0.7rem' }} />
          </a>
          <button
            className="bvh-announcement-close"
            onClick={handleDismiss}
            title="Dismiss announcement"
          >
            <FaTimes />
          </button>
        </div>
      </div>

      {/* Pop Up Official Notice Modal */}
      <AnnouncementNoticeModal
        isOpen={modalState.isOpen}
        onClose={closeNotice}
        noticeType={modalState.noticeType}
      />
    </>
  );
};

export default React.memo(AnnouncementBar);
